import { PATHS } from 'AppConstants';
import { getAxiosConfig } from '../apisSetup/apiConfig';

const axiosApiCaller = getAxiosConfig(PATHS.CCB_URL, true);

export const getGstData = () => axiosApiCaller.get(PATHS.GET_GST);
export const updateGstData = (apidata) => axiosApiCaller.post(PATHS.UPDATE_GST, apidata);
